import script from "./PDFCard.vue?vue&type=script&setup=true&lang=js"
export * from "./PDFCard.vue?vue&type=script&setup=true&lang=js"

import "./PDFCard.vue?vue&type=style&index=0&id=a20b3616&lang=scss&scoped=true"

import exportComponent from "/Users/pontiroli/Desktop/Repositories/eni/dist/eni-dist-eni-for-2022-hub-e-longform/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a20b3616"]])

export default __exports__